// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './components'
import App from './App'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import Axios from 'axios'
import '@/filters'
import _ from 'lodash'

// Plugins
import DatatableFactory from 'vuejs-datatable/dist/vuejs-datatable.esm.js'
import VueOffline from 'vue-offline'
import VCalendar from 'v-calendar'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VeeValidate from 'vee-validate'
import VTooltip from 'v-tooltip'

// Components
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import Default from '@/layouts/Default'
import Modal from '@/layouts/Modal'
import TestLayout from '@/layouts/Test'
import Timeselector from 'vue-timeselector'

import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/css/mdb.min.css'
import '@/assets/css/style.css'
import 'vue-select/dist/vue-select.css'

DatatableFactory.useDefaultType(false).registerTableType('datatable', tableType => {
  tableType.mergeSettings({
    pager: {
      classes: {
        li: 'page-link',
        selected: 'active'
      }
    }
  })
})

Vue.use(DatatableFactory)
Vue.use(VueOffline)
Vue.use(VCalendar)
Vue.use(VModal, { dialog: true })
Vue.use(Notifications)
Vue.use(VueMoment, { moment })
Vue.use(VeeValidate)
Vue.use(VTooltip, {defaultHtml: true})

Vue.component('default-layout', Default)
Vue.component('modal-layout', Modal)
Vue.component('test-layout', TestLayout)
Vue.component('draggable', draggable)
Vue.component('v-select', vSelect)
Vue.component('timeselector', Timeselector)

Vue.prototype.$http = Axios

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$_', { value: _ })

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js